import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getInitialState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },

  [mutation.SHOW_NOTIFICATION](state, text) {
    state.text = text;
    state.show = true;
  },

  [mutation.HIDE_NOTIFICATION](state) {
    state.show = false;
  }
};
